import React, { useContext } from "react";
import "../styles/Profile.css"; // Import the CSS file
import email from "../assets/Email.png";
import profile from "../assets/Owner Name.png";
import phone from "../assets/Phone.png";
import address from "../assets/Location.png";
import about from "../assets/About.png";
import date from "../assets/Date of Birth.png";
import profilePackageRight from '../assets/profile-package-right.png';
import profilePackageLeft from '../assets/profile-package-left.png';
import { LanguageContext } from "../LanguageContext"; // Import the context

const Profile = () => {
  // Retrieve user data from session storage
  const userData = JSON.parse(sessionStorage.getItem("profile"));
  const { language } = useContext(LanguageContext); // Use the context

  // Text content for English and Arabic
  const text = {
    en: {
      email: "Email",
      ownerName: "Owner Name",
      phoneNumber: "Phone Number",
      address: "Address",
      about: "About",
      dateOfEstablishment: "Date of Establishment",
      packageName: "Package Name",
      expireDate: "Expire Date",
    },
    ar: {
      email: "البريد الإلكتروني",
      ownerName: "اسم المالك",
      phoneNumber: "رقم الهاتف",
      address: "العنوان",
      about: "اقرأ عن",
      dateOfEstablishment: "تاريخ التأسيس",
      packageName: "اسم الباقة",
      expireDate: "تاريخ الانتهاء",
    },
  };

  return (
    <>
      <div className="page-banner-profile">
        <div
          className="breadcrumb-profile"
          style={{ backgroundImage: `url(${userData.profilePicture})` }}
        ></div>
      </div>
      <div className="profile-header">
        <img
          src={userData.profilePicture}
          alt="Profile"
          className="profile-picture"
        />
      </div>
      <div className={`profile-container ${language === "ar" ? "rtl" : ""}`}>
        {/* Profile Header */}
        <h4>{userData.fullName}</h4>

        {/* User Details */}
        <div className="user-details">
          <div className="detail-item">
            <span className="detail-label">
              <img src={email} alt="Email" /> {userData.email}
            </span>
            <span className="detail-value">{text[language].email}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">
              <img src={profile} alt="Profile" /> {userData.fullName}
            </span>
            <span className="detail-value">{text[language].ownerName}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">
              <img src={phone} alt="Phone" /> {userData.phone}
            </span>
            <span className="detail-value">{text[language].phoneNumber}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">
              <img src={address} alt="Address" />
              {userData.region.name}, {userData.city.name},{" "}
              {userData.country.name}
            </span>
            <span className="detail-value">{text[language].address}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">
              <img src={about} alt="About" /> {userData.about}
            </span>
            <span className="detail-value">{text[language].about}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">
              <img src={date} alt="Date" /> {text[language].dateOfEstablishment}
            </span>
            <span className="detail-value">
              {new Date(userData.createdAt).toLocaleDateString()}
            </span>
          </div>
        </div>

        {/* Package Details */}
        <div className="package-details">
          <img
            src={profilePackageRight}
            alt="Paw Print"
            className="paw-print-subscription top-right"
          />
          <img
            src={profilePackageLeft}
            alt="Paw Print"
            className="paw-print-subscription bottom-left"
          />
          <div className="content-container">
            <div className="detail-item">
              <span className="detail-label">{text[language].packageName}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">
                {text[language].expireDate}{" "}
                <span className="detail-value">20/1/2025</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;